import React from 'react'

export const PropertyMainImage = ({ propertyImage }) => {
  return (
    <>
      {
        propertyImage ? (
          <img
            src={`${process.env.REACT_APP_WEBSITE}/${propertyImage}`}
            className="rounded-md w-full h-24 object-cover object-center"
          />
        ) : (
          <div>No image available</div>
        )
      }
    </>
  )
}